<template>
  <section class="metodologia-section" id="metodologia">

    <h2 class="section-title-big text-center">Nuestra Metodología de Trabajo</h2>
    <p class="section-sub text-center">
      Procesos claros, entregables definidos y una ejecución alineada a tus objetivos.
    </p>

    <div class="container-custom">
      <div class="row justify-content-center mt-4">
        <div class="col-lg-3 col-md-6 mb-4" v-for="step in steps" :key="step.num">
          <div class="step-card">
            <div class="step-number">{{ step.num }}</div>
            <h3 class="step-title">{{ step.title }}</h3>
            <p class="step-text">{{ step.text }}</p>
          </div>
        </div>
      </div>
    </div>

    <div class="spacer"></div>

    <h2 class="section-title-big text-center">¿Por qué elegir a Leonix?</h2>

    <div class="container-custom">
      <div class="row justify-content-center mt-4">
        <div class="col-lg-4 col-md-6 mb-4" v-for="item in why" :key="item.title">
          <div class="why-card">
            <div class="why-icon" aria-hidden="true">{{ item.icon }}</div>
            <h4 class="why-title">{{ item.title }}</h4>
            <p class="why-text">{{ item.text }}</p>
          </div>
        </div>
      </div>
    </div>

  </section>
</template>

<script>
export default {
  name: 'MetodologiaTrabajo',
  data() {
    return {
      steps: [
        {
          num: 1,
          title: 'Descubrimiento',
          text:
            'Analizamos tus necesidades, procesos y contexto para identificar la mejor solución tecnológica.',
        },
        {
          num: 2,
          title: 'Diseño de la Solución',
          text:
            'Modelamos la arquitectura, definimos el flujo funcional y prototipamos la experiencia de usuario.',
        },
        {
          num: 3,
          title: 'Desarrollo ágil e Integración',
          text:
            'Desarrollamos con enfoque ágil, entregas iterativas, revisiones constantes y código escalable.',
        },
        {
          num: 4,
          title: 'Implementación y Acompañamiento',
          text:
            'Desplegamos la solución, realizamos pruebas, capacitación y soporte después del lanzamiento.',
        },
      ],
      why: [
        {
          icon: '🚀',
          title: 'Trayectoria en tecnología',
          text: 'Más de 10 años construyendo soluciones reales para empresas mexicanas.',
        },
        {
          icon: '🧩',
          title: 'Desarrollo a la medida',
          text: 'Código personalizado, sin plantillas ni soluciones genéricas.',
        },
        {
          icon: '🔗',
          title: 'Experiencia en integraciones',
          text: 'STP, OpenPay, CRMs, ERPs, core bancario y sistemas existentes.',
        },
        {
          icon: '⚡',
          title: 'Metodologías ágiles',
          text: 'Iteraciones rápidas, enfoque a valor y adaptación al cambio.',
        },
        {
          icon: '📊',
          title: 'Resultados medibles',
          text: 'Procesos claros y visibilidad total en cada etapa del proyecto.',
        },
        {
          icon: '🤝',
          title: 'Acompañamiento continuo',
          text: 'Evolucionamos contigo más allá de la entrega.',
        },
      ],
    }
  },
}
</script>

<style scoped>
.container-custom {
  max-width: 1400px;
  margin: 0 auto;
  padding: 0 60px;
}

.metodologia-section {
  background: #0f0f0f;
  padding: 90px 0;
}

.section-title-big {
  color: #fff;
  font-size: 36px;
  font-weight: 800;
  margin-bottom: 10px;
}

.section-sub {
  color: #c7c7c7;
  font-size: 17px;
  max-width: 750px;
  margin: 0 auto 50px;
}

.step-card {
  background: #181818;
  border: 1px solid #2a2a2a;
  border-radius: 18px;
  padding: 30px;
  min-height: 260px;
  transition: 0.3s;
}

.step-card:hover {
  border-color: #f0c060;
  transform: translateY(-6px);
  box-shadow: 0 0 18px rgba(240, 192, 96, 0.15);
}

.step-number {
  width: 40px;
  height: 40px;
  background: #2a2a2a;
  border-radius: 50%;
  color: #f0c060;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  margin-bottom: 12px;
}

.step-title {
  color: #fff;
  font-size: 19px;
  font-weight: 600;
}

.step-text {
  color: #d0d0d0;
  margin-top: 10px;
  font-size: 15px;
  line-height: 1.55;
}

.spacer {
  height: 70px;
}

.why-card {
  background: #ffffff10;
  border: 1px solid #ffffff22;
  border-radius: 20px;
  padding: 40px 25px;
  text-align: center;
  transition: 0.25s ease;
  backdrop-filter: blur(6px);
}

.why-card:hover {
  transform: translateY(-8px);
  border-color: #f5c97a;
  background: #ffffff18;
}

.why-icon {
  font-size: 36px;
  margin-bottom: 12px;
}

.why-title {
  color: #ffffff;
  font-size: 17px;
  font-weight: 600;
  margin-bottom: 8px;
}

.why-text {
  color: #cccccc;
  font-size: 14px;
  line-height: 1.55;
}
</style>
